"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIES_EXPIRATION = exports.PERSISTENT_METADATA_NAMES = exports.PARAMS_COOKIE_NAMES = void 0;
/*
 * key - parameter name
 * value - cookie name
 */
exports.PARAMS_COOKIE_NAMES = {
    partnerId: 'partner_id',
    partnerCampaign: 'partner_campaign',
    partnerParams: 'partner_params',
    campaign: 'campaign',
    referral: 'referral',
    inviteId: 'invite_id',
    impactRadiusClickId: 'ir_click_id',
    impactRadiusAffId: 'aff_id',
    impactRadiusAffSharedId: 'aff_share_id',
    partnerStackPartnerKey: 'partner_stack_partner_key',
};
/*
 * key - parameter name
 * value - cookie name
 */
exports.PERSISTENT_METADATA_NAMES = {
    ga: '_ga',
    satu: '_satu',
};
// Expiration time in days. Session cookie used if expiration is not set.
exports.COOKIES_EXPIRATION = {
    campaign: 365,
    impactRadiusClickId: 365,
};
//# sourceMappingURL=config.js.map